export const SET_INFO = 'set_info'
export const SET_AUTH = 'set_auth'
export const CHECK_AUTH = 'check_auth'
export const SET_TIME = 'set_time'




// WEBPACK FOOTER //
// ./src/store/actions.type.js